import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Clock, ArrowRight } from 'lucide-react';
import { companyInfo, services } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1B4F5D] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={companyInfo.logo} 
              alt="CitiBiz Connections" 
              className="h-16 w-auto"
            />
            <p className="text-gray-300 leading-relaxed">
              A dynamic logistics and trade support company based in Ghana, committed to delivering reliable and efficient shipping solutions.
            </p>
            <div className="flex gap-4">
              <a 
                href={companyInfo.social.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#408D4D] transition-colors duration-300"
              >
                <Facebook size={18} />
              </a>
              <a 
                href={companyInfo.social.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#408D4D] transition-colors duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 relative">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-[#408D4D]" />
            </h3>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Services', 'Track Shipment', 'Contact'].map((item) => (
                <li key={item}>
                  <Link 
                    to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-').replace('track-shipment', 'tracking')}`}
                    className="text-gray-300 hover:text-[#408D4D] transition-colors flex items-center gap-2 group"
                  >
                    <ArrowRight size={14} className="opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 relative">
              Our Services
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-[#408D4D]" />
            </h3>
            <ul className="space-y-3">
              {services.slice(0, 5).map((service) => (
                <li key={service.id}>
                  <Link 
                    to="/services"
                    className="text-gray-300 hover:text-[#408D4D] transition-colors flex items-center gap-2 group"
                  >
                    <ArrowRight size={14} className="opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" />
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 relative">
              Contact Us
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-[#408D4D]" />
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#408D4D] flex-shrink-0 mt-1" />
                <span className="text-gray-300">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#408D4D] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-300 hover:text-[#408D4D] transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#408D4D] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-300 hover:text-[#408D4D] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={20} className="text-[#408D4D] flex-shrink-0 mt-1" />
                <div className="text-gray-300">
                  <p>Monday - Friday</p>
                  <p>8:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} CitiBiz Connections. All rights reserved. Built and Managed by{' '}
              <a 
                href="https://www.nitlimited.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#408D4D] hover:text-white transition-colors"
              >
                Nusite IT Consulting Limited
              </a>
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/" className="text-gray-400 hover:text-[#408D4D] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/" className="text-gray-400 hover:text-[#408D4D] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
